import { ApiLocalizedData } from "../../types/RedBeeTypes";
import { IBasicTableItem } from "../components/Table/BasicTable";

export class Asset implements IBasicTableItem {
  localized: Array<ApiLocalizedData>;
  assetId: string;
  changed: string;
  created: string;
  publications: Array<any>;
  constructor() {
    this.localized = [];
    this.changed = "";
    this.created = "";
    this.publications = [];
  }
  getTitle(locale = "en") {
    if (!this.localized || this.localized.length === 0) {
      return "";
    }
    const localeItem =
      this.localized.find((l) => l.locale === locale) || this.localized[0];
    return localeItem.title;
  }
  getImage(locale = "en") {
    if (!this.localized || this.localized.length === 0) {
      return "";
    }
    const localeItem =
      this.localized.find((l) => l.locale === locale) || this.localized[0];
    if (!localeItem.images || localeItem.images.length === 0) {
      return "";
    }
    return localeItem.images[0].url;
  }

  getDisplayName(locale?: string) {
    return this.getTitle();
  }
  getUniqueId() {
    return this.assetId;
  }

  get createdDate() {
    return this.created;
  }

  get changedDate() {
    return this.changed;
  }

  get isPublished() {
    return !!this.publications.length.toString();
  }
}
